import { EntitiesStore } from "./entities-store.abstract";
import { HttpClient } from "@angular/common/http";
import { CountryDependencyEntityStore } from './country-dependency-entity-store';
import { Injector } from '@angular/core';


/**
 *
 *
 * @export
 * @interface Athlete
 */
export interface IAthlete {
  Id: string;
  FName: string;
  GName: string;
  WNameOrd: boolean;
  NOC: string;
}

/**
 * Interface for Detail of WorldRanking.
 *
 * @export
 * @interface IWorldRankingDetail
 */
export interface IWorldRankingDetail {
  ID: string;
  Name: string;
  NameShort: string;
  Place: string;
  Country: string;
  Date: string;
  Position: number;
  Points: number;
  InTotal: boolean;
}

/**
 * Interface for world rankings store.
 *
 * @export
 * @interface IWorldRankingStore
 */
export interface IWorldRankingStore {
  Rnk: number;
  RnkOld: number;
  Cat: string;
  Points: number;
  RnkDtIssued: string;
  Athlete: IAthlete;
  Details: IWorldRankingDetail[];
}
/**
 * Storage for world rankings.
 *
 * @export
 * @class WorldRankingStore
 * @extends {EntitiesStore<IWorldRankingStore>}
 */
export class WorldRankingStore extends EntitiesStore<IWorldRankingStore>{
  constructor(http: HttpClient) {
    super('WORLDRANKINGS', http);
  }
}
